/* eslint-disable no-restricted-globals */

import { h, render } from 'preact'
import { lazy, Suspense } from 'preact/compat'
import { define } from 'preactement'

import Spinner from '@components/spinner/Spinner'
import Navbar from '@features/navbar/Navbar'
import initCookies from '@features/cookies/initCookies'

const FlyoutWishlist = lazy(() => import('features/wishlist/FlyoutWishlist'))
const FlyoutCart = lazy(() => import('features/cart/FlyoutCart'))
const QuickSearch = lazy(() => import('features/elastic/search/QuickSearch'))
const DrawerMenu = lazy(() => import('features/drawerMenu/DrawerMenu'))

export default function renderSharedUI() {
	define('wui-navbar', () => Navbar)

	const wishlistIcon = document.getElementById('menu-item--wishlist')
	const cartIcon = document.getElementById('menu-item--cart')
	const searchIcon = document.querySelector('[data-drawer-toggle=search]')
	const menuIcon = document.querySelector('[data-drawer-toggle=menu]')
	const quickSearch = document.getElementById('modal-quicksearch')
	const wishlist = document.getElementById('modal-wishlist')
	const cart = document.getElementById('modal-cart')

	const renderMenu = () => {
		const menu = document.getElementById('modal-menu')

		if (menu)
			render(
				<Suspense fallback={<Spinner />}>
					<DrawerMenu />
				</Suspense>,
				menu,
			)
	}

	const renderQuickSearch = () => {
		if (quickSearch)
			render(
				<Suspense fallback={<Spinner />}>
					<QuickSearch />
				</Suspense>,
				quickSearch,
			)
	}

	const renderWishlist = () => {
		const { title } = wishlist.dataset

		if (wishlist)
			render(
				<Suspense fallback={<Spinner />}>
					<FlyoutWishlist title={title} />
				</Suspense>,
				wishlist,
			)
	}

	const renderCart = () => {
		if (location.pathname === '/cart') {
			// don't render cart at all here
			return
		}

		if (cart)
			render(
				<Suspense fallback={<Spinner />}>
					<FlyoutCart {...cart.dataset} />
				</Suspense>,
				cart,
			)
	}

	if (menuIcon) {
		const renderMenuIfNotRendered = () => {
			renderMenu()
			menuIcon.removeEventListener('click', renderMenuIfNotRendered)
		}

		menuIcon.addEventListener('click', renderMenuIfNotRendered)
	}

	if (searchIcon) {
		const renderSearchIfNotRendered = () => {
			renderQuickSearch()
			searchIcon.removeEventListener('click', renderSearchIfNotRendered)
		}

		searchIcon.addEventListener('click', renderSearchIfNotRendered)
	}

	if (cartIcon) {
		window.__CART_RENDERED = false

		const renderCartIfNotRendered = () => {
			if (!window.__CART_RENDERED) {
				renderCart()

				cartIcon.removeEventListener('click', renderCartIfNotRendered)
			}
		}

		cartIcon.addEventListener('click', renderCartIfNotRendered)
	}

	if (wishlistIcon) {
		const renderWishListIfNotRendered = () => {
			if (!window.__WISHLIST_RENDERED) {
				renderWishlist()

				wishlistIcon.removeEventListener('click', renderWishListIfNotRendered)
			}
		}

		wishlistIcon.addEventListener('click', renderWishListIfNotRendered)
	}

	// Add listeners to cookie bar
	initCookies()

	// Set location function needed by some nopCommerce views
	// Todo: remove this when we have a better solution
	window.setLocation = url => {
		window.location = url
	}
}
